import { BedIcon, MoodGreatIcon, TrendsIcon } from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

import type { AccuracyCardProps } from '@/app/components/LandingPage/LandingPageAccuracy/AccuracyCard';

const accuracyCards: AccuracyCardProps[] = [
  {
    heading: 'business_improved_data_top',
    icon: BedIcon as SVGIconComponent,
    percentage: 0.88,
  },
  {
    heading: 'business_improved_data_middle',
    icon: MoodGreatIcon as SVGIconComponent,
    percentage: 0.74,
  },
  {
    heading: 'business_improved_data_bottom',
    icon: TrendsIcon as SVGIconComponent,
    percentage: 0.79,
  },
];

export default accuracyCards;
